var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_99_32",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.125 0.5H0.125V19.5H19.125V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_99_32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.68799 7.229H11.208",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.68799 9.604H8.43799",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.68799 4.854H9.22899",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.68799 11.979H6.85399",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.68799 14.354H6.85399",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.437 19.1043H1.312C1.102 19.1043 0.900999 19.0209 0.751999 18.8725C0.603999 18.724 0.520996 18.5226 0.520996 18.3127V1.6877C0.520996 1.4777 0.603999 1.2763 0.751999 1.1279C0.900999 0.979396 1.102 0.895996 1.312 0.895996H11.836C12.046 0.896036 12.247 0.979476 12.396 1.128L15.33 4.0627C15.479 4.2111 15.562 4.4124 15.562 4.6224V7.2293",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.625 14.3542C9.625 15.509 10.084 16.6165 10.9 17.433C11.717 18.2496 12.824 18.7083 13.979 18.7083C15.134 18.7083 16.241 18.2496 17.058 17.433C17.875 16.6165 18.333 15.509 18.333 14.3542C18.333 13.1994 17.875 12.0919 17.058 11.2753C16.241 10.4587 15.134 10 13.979 10C12.824 10 11.717 10.4587 10.9 11.2753C10.084 12.0919 9.625 13.1994 9.625 14.3542Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9801 11.9786V16.7286",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9801 16.7286L15.7611 14.9473",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9801 16.7286L12.1981 14.9473",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportFile);
export default __webpack_public_path__ + "static/media/export-file.cdc19f06ee12f1219c8a3a3c041ebd33.svg";
export { ForwardRef as ReactComponent };